module.exports = __webpack_public_path__ + "img/loans.57f364f7.svg";